import * as React from 'react';
import { IButtonProps } from 'telia-front-react';

import ButtonWithAnalytics from './ButtonWithAnalytics';

export interface ILinkButtonProps {
  gaEvent: string;
  buttonProps?: IButtonProps;
}

export default class LinkButton extends React.Component<ILinkButtonProps> {
  public render(): JSX.Element {
    return <ButtonWithAnalytics gaEvent={this.props.gaEvent} buttonProps={{ isUnderlined: false, link: true, ...this.props.buttonProps }} />;
  }
}
